import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectPersons } from "~components/SelectPersons/SelectPersons";
import { ImageTypes } from "~enums/imageTypes";
import type { Person } from "~types/person";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";
import { StyledCompetitorCell } from "./Columns.styles";

interface IPersonsColumnProperties extends ColumnComponentProperties {
  persons?: Person[];
  isHome: boolean;
  oppositePersons?: Person[];
}
export const PersonsColumn = ({ fixtureId, editMode, isHome, oppositePersons, persons }: IPersonsColumnProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();
  if (editMode) {
    const values =
      persons?.map((x) => ({
        label: x.nameFullLocal,
        value: x.personId,
      })) ?? [];
    const onChangeHandler = (participantOptions: InfinitySelectOption[]) => {
      const participants: {
        isHome: boolean;
        personId: string;
      }[] = [];
      if (!isEmpty(participantOptions)) {
        participantOptions
          .filter((x) => !isEmpty(x))
          .forEach((x) => {
            participants.push({
              personId: x.value,
              isHome,
            });
          });
      }
      if (!isEmpty(oppositePersons)) {
        oppositePersons?.forEach((x) => {
          participants.push({
            personId: x.personId,
            isHome: !isHome,
          });
        });
      }
      updateFixture({
        fixtureId,
        upsertData: {
          participants: participants,
        },
      });
    };
    return (
      <SelectPersons
        disabled={isLoading}
        placeholder={formatMessage({
          id: `fixtureListPage.table.column.editMode.${isHome ? "homeParticipants" : "awayParticipants"}.placeholder`,
        })}
        value={values}
        onChange={onChangeHandler}
        rightAligned={isHome}
        disabledOptionValues={oppositePersons?.map((x) => x.personId)}
      />
    );
  }
  return (
    persons?.map((person: Person, index: number) => {
      return (
        <StyledCompetitorCell key={`persons-name-wrapper-${person?.personId || 0}-${index}`} $isReverse={isHome}>
          {person && <DataTableImageColumn images={person?.images} imageTypes={[ImageTypes.PersonHead]} />}
          <span>{person?.nameFullLocal}</span>
        </StyledCompetitorCell>
      );
    }) ?? null
  );
};
